"use client";

import styles from "./LoginPageContainer.module.scss";
import { ReactNode } from "react";

/**
 * LoginPageContainer Component
 *
 * Wrapper component for main login content area.
 * Provides styling and layout structure for login form and banner.
 */
export const LoginPageContainer = ({ children }: { children: ReactNode }) => {
  return <div className={styles["comp"]}>{children}</div>;
};
